import $ from 'jquery';
window.jQuery = $;
require('@fancyapps/fancybox/dist/jquery.fancybox.min.js');

function init(config) {

    const galleries = $(config.gallery);
    if (galleries.length) {
        galleries.fancybox({
            loop: true
        });
    }

}

export default { init: init }